import { useState } from "react";
import { API } from "./api";
import logo from "./mindpro_technologies_logo.png";

export default function Login({ setAuth }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    try {
      const res = await API.post("/login", {
        username,
        password
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role);

      setAuth(res.data.role);

    } catch (err) {
      alert("❌ Invalid credentials");
    }
  };

  return (
    <div style={styles.container}>

      {/* 🔝 HEADER */}
      <div style={styles.header}>
        <img src={logo} alt="logo" style={styles.logo} />
        <h3 style={{ margin: 0 }}>Inventory Platform</h3>
      </div>

      {/* 🔐 LOGIN BOX */}
      <div style={styles.center}>
        <div style={styles.card}>

          <h2 style={styles.title}>🔐 Login</h2>

          <input
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />

          <button onClick={login} style={styles.button}>
            Login
          </button>

        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    background: "linear-gradient(135deg, #1e3a8a, #0f172a, #111827)",
    backgroundSize: "400% 400%",
    animation: "gradientMove 10s ease infinite",
    display: "flex",
    flexDirection: "column"
  },

  header: {
    display: "flex",
    alignItems: "center",
    padding: "15px 30px",
    color: "white"
  },

  logo: {
    height: 40,
    marginRight: 10
  },

  center: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  card: {
    width: 350,
    padding: 30,
    borderRadius: 15,
    background: "rgba(255,255,255,0.1)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 15px 40px rgba(0,0,0,0.4)",
    color: "white",
    animation: "fadeIn 1s ease"
  },

  title: {
    textAlign: "center",
    marginBottom: 20
  },

  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "none",
    outline: "none"
  },

  button: {
    width: "100%",
    padding: "12px",
    background: "linear-gradient(90deg, #2563eb, #3b82f6)",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "0.3s"
  }
};